const contactFormPharmacy = {
  page: {
    title: 'Apotheke kontaktieren',
    description: 'Bei Fragen zu Preisen, Verfügbarkeiten oder dem Apothekensortiment, nutzen Sie bitte das untenstehende Kontaktformular. Wir leiten Ihre Anfrage unverzüglich an das Team Ihrer ausgewählten Apotheke weiter.',
  },
  forms: {
    salutation: 'Anrede',
    firstName: 'Vorname *',
    lastName: 'Nachname *',
    phoneNumber: 'Telefonnummer',
    email: 'E-Mail-Adresse *',
    message: 'Ihre Nachricht *',
    ourPromise: '{strongText} Wir nutzen die Telefonnummer nur für eventuelle Rückfragen der Apotheke zu Ihren Vorbestellungen. Außerdem werden Sie per SMS und E-Mail über den Status Ihrer Bestellung informiert.',
    ourPromiseTitle: 'Unser Versprechen:',
    policy: {
      termsOfUse: 'Nutzungsbedingungen',
      privacyPolicy: 'Datenschutzbestimmungen',
      1: 'Die',
      2: 'und',
      3: 'habe ich zur Kenntnis genommen und bin mit ihrer Geltung einverstanden.',
    },
    send: 'Senden',
  },
  success: {
    title: 'Kontaktformular',
    description: 'Vielen Dank für Ihre Nachricht an die Testapotheke IhreApotheken.de. Ihre Apotheke wird sich schnellstmöglich mit Ihnen in Verbindung setzen. Wir haben eine Kopie Ihrer Nachricht an die von Ihnen angegebene E-Mail-Adresse gesendet.',
    button: 'Zur Startseite',
  },
}

export default contactFormPharmacy
